module.exports = __webpack_public_path__ + "img/wepayqrcode.612db5f9.jpg";